(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/components/transcript-ordered-thankyou.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/components/transcript-ordered-thankyou.js');
'use strict';

const TranscriptOrderedThankYou = _ref => {
  let {
    thankYouText
  } = _ref;
  return React.createElement("span", null, "Tack f\xF6r din best\xE4llning. Vi arbetar p\xE5 att ta fram ditt ".concat(thankYouText, " s\xE5 fort som m\xF6jligt. Du f\xE5r ett mail n\xE4r det \xE4r redo att laddas ned."));
};
svs.myProfile.react.pages.myInformation.transcript.transcript.TranscriptOrderedThankYou = TranscriptOrderedThankYou;

 })(window);